<template>
  <footer>
			<div class="wrapper">
				<div class="wrap">
                    <ul class="nav top">
						<li @click="$router.push('/')" :class="[{'active':$route.name=='home'}]">{{$t('home')}}</li>
						<li @click="$router.push('/products')" :class="[{'active':$route.name=='products'}]">{{$t('products')}}</li>
						<li @click="$router.push('/service')" :class="[{'active':$route.name=='service'}]">{{$t('service')}}</li>
						<li @click="$router.push('/about')" :class="[{'active':$route.name=='about'}]">{{$t('about')}}</li>
					</ul><br>
					<p v-html="$t('footer.risk2')" class="desc"></p><br>
					<p>{{ $t('footer.copyright') }}</p>

					<!-- <ul class="nav" v-if="language=='zh_CN'">
						<li><router-link :to="{name:'privacy_cn'}">{{$t('footer.privacy')}}</router-link></li> | 
						<li><router-link :to="{name:'agreement_cn'}">{{$t('footer.clientAgreement')}}</router-link></li>
					</ul> -->
					<ul class="nav">
						<li><router-link :to="{name:'privacy'}">{{$t('footer.privacy')}}</router-link></li> | 
						<li><router-link :to="{name:'agreement'}">{{$t('footer.clientAgreement')}}</router-link></li>
					</ul>
				</div>
				<div class="right">
                    <div class="lang">
                        <img src="@/assets/images/language.svg" width="20"><p>{{$i18n.locale=='zh_CN'?'中文':'EN'}}</p>
                    </div>
                    <p class="contact" v-html="$t('footer.contact')"></p>
                </div>
			</div>
		</footer>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>
<style lang="scss" scoped>
	footer{			
        background-color: #171717;
        padding: 30px 0 100px 0;
        //border-bottom: 1px solid #1a1e43;
        
        .wrapper{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            color: #fff;
            .wrap{				 
                width: 70%;    
                padding-right: 1rem;
                .nav{
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                    margin: .3rem auto;
                    &.top{
                        margin: 0 auto .3rem auto;
                    }
                    li{
                        margin-right: 30px;
                        a,a:visited{
                            color: white;
                        }
                    }
                }
                .desc{
                    font-size: .24rem;
                }
            }
            .right{
                width: 30%;
                min-height: 5rem;
                border-left: 1px solid rgba($color: #fff, $alpha: .1);
                padding: 0 0 0 1rem;
                font-size: .24rem;
                color: #999;
                .lang{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: .3rem;
                    color: #fff;
                }
                .contact{
                    margin-top: .6rem;
                }
                img{
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                    width: .6rem;
                }
                
            }
        }
    }
     /*mobile*/
    @media screen and (max-width: 1024px) {
        footer {
            .wrapper{
                display: block;
                width: 100%;
                padding: .3rem;
                color: #999;
                text-align: center;
                .wrap{
                    width: 100%;
                    padding: 0;
                    .nav{
                        display: none;
                    }
                }
                .right{
                    display: none;
                }
            }
        }
    }
</style>
